import 'regenerator-runtime/runtime';
import './cross-site-search.scss';
import './cross-site-search.html.twig';
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { connectPagination } from 'instantsearch.js/es/connectors';
import { configure, searchBox, refinementList, stats, hits } from 'instantsearch.js/es/widgets';

export default () => {
  const siteSearch = document.querySelector('.search');

  if (!siteSearch) {
    return;
  }

  const order = {
    Course: 1,
    'Blog post': 2,
    Fees: 3,
    'CPC Company': 4,
  };

  const appID = drupalSettings.algolia.settings.applicationID;
  const apiKey = drupalSettings.algolia.settings.apiKey;
  const indexName = drupalSettings.algolia.settings.indexName;
  const initialSearch = drupalSettings.algolia.settings.initialSearch;

  const mobileQuery = window.matchMedia('(max-width: 768px)');
  let snippet;
  if (mobileQuery.matches) {
    snippet = ['summary:5', 'text:5'];
  } else {
    snippet = ['summary:20', 'text:20'];
  }

  (async () => {
    // Modify .search__main element.
    const searchMainElement = document.querySelector('.search__main');
    searchMainElement.setAttribute('tabindex', '-1');

    const search = await instantsearch({
      indexName,
      searchClient: algoliasearch(appID, apiKey),
    });

    // Custom widget to set the inital query from text provided by drupal.
    search.addWidgets([
      {
        init: function (options) {
          if (initialSearch) {
            options.helper.setQuery(initialSearch);
          }
        },
      },
    ]);

    search.addWidgets([
      configure({
        hitsPerPage: 10,
        attributesToSnippet: snippet,
        snippetEllipsisText: '…',
        restrictHighlightAndSnippetArrays: true,
        facetingAfterDistinct: true,
      }),
    ]);

    search.addWidgets([
      searchBox({
        container: '.search__search-box',
        placeholder: 'Search CIOB',
        magnifier: false,
        reset: false,
      }),
    ]);

    search.addWidgets([
      refinementList({
        container: '#brand-list',
        attribute: 'type',
        templates: {
          item: `
              <a href="{{url}}" style="{{#isRefined}}font-weight: bold{{/isRefined}}">
                <span>{{label}} ({{count}})</span>
              </a>
            `,
        },
        sortBy: ['count:desc', 'name:asc'],
      }),
    ]);

    search.addWidgets([
      stats({
        container: '.search__stats',
        templates: {
          text({ hitsPerPage, page, nbHits, hasManyResults, hasOneResult }) {
            const resultsFrom = hitsPerPage * page + 1;
            const resultsTo = Math.min(resultsFrom + hitsPerPage - 1, nbHits);
            let count = '';
            if (hasManyResults) {
              count += `${nbHits}`;
            } else if (hasOneResult) {
              count += `1 result`;
            } else {
              count += `no result`;
            }

            if (resultsTo === 0) {
              return '';
            }

            return `<span class="search__stats__hits">${resultsFrom}-${resultsTo}</span> of <span class="search__stats__hits">${count}</span> results found`;
          },
        },
      }),
    ]);

    search.addWidgets([
      hits({
        container: '.search__hits',
        transformItems(items) {
          return items.map((item) => ({
            ...item,
            date: new Date(item.date * 1000).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            }),
          }));
        },
        templates: {
          empty: function (context) {
            return (
              '<h3>Nothing to see here</h3><div>Sorry, we couldn’t find anything for "' +
              context.query +
              '". Please try another search or return <a href="/">home</a>.</div>'
            );
          },
          item: (hit) => {
            const { type, date, title, url, source } = hit;
            const summary = instantsearch.snippet({ attribute: 'summary', hit });
            const text = instantsearch.snippet({ attribute: 'text', hit });
            const description = (hit._highlightResult && hit._highlightResult.summary && hit._highlightResult.summary.matchLevel !== "none") ? summary : text;
            if (type === 'news') {
              return `<div class="search-card search-card--${type}">
                <div class="search-card__meta">
                  <div class="search-card__label">${type}</div>
                  <div class="search-card__date">${date!== 'Invalid Date' ? date : ''}</div>
                </div>
                <div class="search-card__title">
                  <h5><a href="${url}" target="_blank">${title}</a></h5>
                </div>
                <div class="search-card__description">
                  <p>
                    ${description}
                  </p>
                </div>
                <div class="search-card__button">
                  Find out more <span></span>
                </div>
              </div>`;
            }
            return `<div class="search-card search-card--${type} search-card--source-${source}">
                <div class="search-card__meta">
                  <div class="search-card__label">
                    ${type}
                    <span class="search-card__icon"></span>
                  </div>
                  <div class="search-card__date">${date!== 'Invalid Date' ? date : ''}</div>
                </div>
                <div class="search-card__title">
                  <h5><a href="${url}">${title}</a></h5>
                </div>
                <div class="search-card__description">
                  <p>
                    ${description}
                  </p>
                </div>
                <div class="search-card__button">
                  ${type === 'Document' ? 'Download this document' : 'Find out more'} <span></span>
                </div>
              </div>`;
          },
        },
      }),
    ]);

    // Create the render function
    const renderPagination = (renderOptions) => {
      const {
        pages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
        currentRefinement,
        nbPages,
      } = renderOptions;

      const container = document.querySelector('.search__pagination');

      container.innerHTML = `
        <div class="ais-Pagination">
          <ul class="ais-Pagination-list">
            ${PaginationLink({
              ariaLabel: "Previous",
              isDisabled: isFirstPage,
              label: "Previous",
              pageNumber: currentRefinement - 1,
              createURL: createURL,
              cssClasses: {
                li: `ais-Pagination-item ais-Pagination-item--previousPage${!currentRefinement ? ' ais-Pagination-item--disabled' : ''}`,
                link: 'ais-Pagination-link',
              },
            })}

            ${pages.map((pageNumber) => (
              PaginationLink({
                key: pageNumber,
                ariaLabel: `Go to page ${pageNumber + 1}`,
                isSelected: pageNumber === currentRefinement,
                label: pageNumber + 1,
                pageNumber: pageNumber,
                createURL: createURL,
                cssClasses: {
                  li: `ais-Pagination-item ais-Pagination-item--page${pageNumber === currentRefinement ? ' ais-Pagination-item--selected' : ''}`,
                  link: 'ais-Pagination-link',
                },
              })
            )).join('')}

            ${PaginationLink({
              ariaLabel: "Next",
              isDisabled: isLastPage,
              label: "Next",
              pageNumber: currentRefinement + 1,
              createURL: createURL,
              cssClasses: {
                li: `ais-Pagination-item ais-Pagination-item--nextPage${nbPages === currentRefinement + 1 ? ' ais-Pagination-item--disabled' : ''}`,
                link: 'ais-Pagination-link',
              },
            })}
          </ul>
        </div>
      `;

      function PaginationLink({label, ariaLabel, pageNumber, isDisabled = false, cssClasses, createURL}) {
        return `
          <li class="${cssClasses.li}">
            ${isDisabled ?
              `<span class="${cssClasses.link}">${label}</span>`
             : (
              `<a
                class="${cssClasses.link}"
                aria-label="${ariaLabel}"
                href="${createURL(pageNumber)}"
                data-value="${pageNumber}"
              >${label}</a>`
            )}
          </li>
        `;
      }

      [...container.querySelectorAll('a')].forEach((element) => {
        element.addEventListener('click', event => {
          event.preventDefault();
          refine(event.currentTarget.dataset.value);

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });

          setTimeout(function() {
            searchMainElement.focus();
          }, 500);
        });
      });
    };

    // Create the custom widget
    const customPagination = connectPagination(
      renderPagination
    );

    // Instantiate the custom widget
    search.addWidgets([
      customPagination({
        container: '.search__pagination',
      }),
    ]);

    search.start();

    // Adapt logic for search box.
    const searchBoxElement = document.querySelector('.search__search-box');
    if (searchBoxElement) {
      const searchBoxInputElement = document.querySelector('.ais-SearchBox-input');
      const searchBoxFormButtonsElement = [...document.querySelectorAll('.ais-SearchBox-form button')];

      searchBoxInputElement.setAttribute('id', 'search_term');
      searchBoxInputElement.setAttribute('aria-describedby', 'search_term_hint');

      const searchInputLabel = document.createElement('label');
      searchInputLabel.setAttribute('for', 'search_term');
      searchInputLabel.setAttribute('class', 'sr-only');
      searchInputLabel.innerHTML = 'Search results for';
      const searchInputSpan = document.createElement('span');
      searchInputSpan.setAttribute('id', 'search_term_hint');
      searchInputSpan.innerHTML = 'Content will update upon entering search term';

      searchBoxElement.append(searchInputSpan);
      searchBoxElement.prepend(searchInputLabel);

      searchBoxInputElement.addEventListener('focus', function(e) {
        searchBoxFormButtonsElement.forEach((element) => {
          element.style.display = 'none';
        });

        document.querySelector('.ais-Stats-text').removeAttribute('role');
      });

      searchBoxInputElement.addEventListener('blur', function(e) {
        searchBoxFormButtonsElement.forEach((element) => {
          element.style.display = 'block';
        });

        document.querySelector('.ais-Stats-text').setAttribute('role', 'status');
      });
    }
  })();
};
